module.exports = __webpack_public_path__ + "img/ios_safari_share.06c61699.png";